<template>
    <div>
  <input v-model="barcodeValue" /><br>
  <barcode v-bind:value="barcodeValue" format="CODE128">
    Show this if the rendering fails.
  </barcode>
  <barcode v-bind:value="barcodeValue" format="CODE39">
    Show this if the rendering fails.
  </barcode>
    </div>
</template>

<script>
import VueBarcode from 'vue-barcode';

export default {
     components: {
    'barcode': VueBarcode
  },
  data() {
      return {
          barcodeValue:''
      }
  },
}
</script>